import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import Panel from '../Panel';
import { PlayoffLeaderboardContainer } from '../PlayoffLeaderboard';
import StandingsPreview from '../StandingsPreview';

const Leaderboard = ({
    season,
    leaderboard,
    leaderboardOptions,
    onLeaderboardChange,
}) => (
    <Panel
        title="Leaderboard"
        removeContentPadding
    >
        { leaderboardOptions && leaderboardOptions.length > 1 && (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingBottom: '8px'
                }}
            >
                <ToggleButtonGroup
                    size="small"
                    color="secondary"
                    exclusive
                    value={leaderboard}
                    onChange={({ target: { value }}) => onLeaderboardChange(value)}
                >
                    { leaderboardOptions.map(option => <ToggleButton value={option}>{option}</ToggleButton>)}
                </ToggleButtonGroup>
            </Box>
        )}
        {
            leaderboard === 'season' ? (
                <StandingsPreview
                    teams={season?.teams}
                />
            ) : (
                <PlayoffLeaderboardContainer
                    playoffs={season?.playoffs}
                    playoffBoard={season?.playoffBoard}
                    splitPlayoffs={season?.splitPlayoffs}
                />
            )
        }
    </Panel>
);

export default Leaderboard;